import styled, { css } from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

export const Form = styled.form`
  padding: 0 10px;
`

export const TextInputGrid = styled.div`
  display: grid;
  grid-column-gap: 10px;
  grid-row-gap: 15px;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  margin: 30px 0 50px;

  ${fromMd} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const StarSelectorWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`

export const ErrorMessage = styled.span`
  color: ${o => o.theme.color.deprecated.red.error};
  display: block;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 1px;
  padding-top: 8px;
`

export const FormErrorMessage = styled(ErrorMessage)`
  margin-bottom: 20px;
  text-align: center;
`

export const InputLabel = styled.span<{
  required?: boolean
}>`
  display: block;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 2px;
  margin-bottom: 8px;
  text-transform: uppercase;

  ${({ required, theme }) =>
    required &&
    css`
      &::after {
        color: ${theme.color.deprecated.red.error};
        content: '*';
      }
    `}
`

export const ReviewBodyTextAreaWrapper = styled.label`
  ${fromMd} {
    grid-column: span 2 / span 2;
  }
`

export const PostCtaWrapper = styled.div`
  button {
    display: block;
    margin: auto;
  }
`
